<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>Access</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/settings/access">Access</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-row>
            <b-col md='8' class="mb-3">
                <div class="d-flex">
                    <span class="my-3 dashboard-access"><router-link to="/settings/access/user-access">User Access</router-link></span>
                    <span class="ml-4 my-3 dashboard-access active"><router-link style="color:#0056b3!important;" to="/settings/access/module-access">{{$route.name}}</router-link></span>
                </div>
            </b-col>
        </b-row>
        <div class="border-bottom mb-4"></div>
        <form action="#">
            <b-row>
                <b-col md="4">
                    <fieldset class="border p-3 mb-4">
                    <legend class="w-auto legend-name labels">{{ model.userAdmin }}</legend>
                        <div>
                            <b-form-checkbox-group
                                v-model="admin"
                                :value="admin"
                                :options="moduleAdmin"
                                stacked
                            >
                            </b-form-checkbox-group>
                        </div>
                    </fieldset>
                </b-col>
                <b-col md="4">
                    <fieldset class="border p-3 mb-4">
                    <legend class="w-auto legend-name labels">{{ model.userManager }}</legend>
                        <div>
                            <b-form-checkbox-group
                                v-model="valueManager"
                                :options="moduleManager"
                                stacked
                            >
                            </b-form-checkbox-group>
                        </div>
                    </fieldset>
                </b-col>
                <b-col md="4">
                    <fieldset class="border p-3">
                    <legend class="w-auto legend-name labels">{{ model.userTransportation }}</legend>
                        <div>
                            <b-form-checkbox-group
                                v-model="valueTransportation"
                                :options="moduleTransportation"
                                stacked
                            >
                            </b-form-checkbox-group>
                        </div>
                    </fieldset>
                </b-col>
            </b-row>
        </form>
        <b-row class="mt-4">
            <b-col md="12">
              <b-button variant="warning" class="btn-back float-right" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Update
              </b-button>
            </b-col>
          </b-row>
    </b-card>
</template>
<script>
    export default {
        name: 'module-access',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    userAcl: window.AppConfig.apiUrl + 'user-acl?limit=100',
                    userModule: window.AppConfig.apiUrl + 'user-module?limit=100',
                    userRole: window.AppConfig.apiUrl + 'user-role?limit=100',
                    moduleAction: window.AppConfig.apiUrl + 'user-acl-update'
                },
                model: {
                    userAdmin: '',
                    adminUuid: '',
                    userManager: '',
                    managerUuid: '',
                    userTransportation: '',
                    transportationUuid: ''
                },
                valueAdmin: [],
                moduleAdmin: [],
                valueManager: [],
                moduleManager: [],
                valueTransportation: [],
                moduleTransportation: [],
                admin: [],
                manager: [],
                transportation: []
            }
        },
        mounted() {
            this.getUserRole()
            this.getUserAcl()
            this.getModuleUser()
        },
        methods: {
            getModuleUser() {
                this.$http.get(this.apiUrl.userModule).then(response => {
                    response.data._embedded.user_module.forEach(data => {
                        this.moduleAdmin.push({
                            value: data.uuid,
                            text: data.name
                        })
                        this.moduleManager.push({
                            value: data.uuid,
                            text: data.name
                        })
                        this.moduleTransportation.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getUserRole() {
                this.$http.get(this.apiUrl.userRole).then(response => {
                    response.data._embedded.user_role.forEach(data => {
                        if (data.name === 'ADMIN') {
                            this.model.userAdmin = data.name
                            this.model.adminUuid = data.uuid
                        }
                        if (data.name === 'MANAGER') {
                            this.model.userManager = data.name
                            this.model.managerUuid = data.uuid
                        }
                        if (data.name === 'TRANSPORTATION') {
                            this.model.userTransportation = data.name
                            this.model.transportationUuid = data.uuid
                        }
                    })
                })
            },
            getUserAcl() {
                this.$http.get(this.apiUrl.userAcl).then(response => {
                    response.data._embedded.user_acl.forEach(data => {
                        if (data.userRole.name === "ADMIN") {
                            this.admin.push({
                                value: data.uuid,
                                text: data.userModule.name
                            })
                        }
                        if (data.userRole.name === "MANAGER") {
                            this.manager.push({
                                value: data.uuid,
                                text: data.userModule.name
                            })
                        }
                        if (data.userRole.name === "TRANSPORTATION") {
                            this.transportation.push({
                                value: data.uuid,
                                text: data.userModule.name
                            })   
                        }
                    })
                })
            },
            doEdit() {
                const toEdit = this.selectedItems.map((selectedItem) => ({
                    uuid: selectedItem.uuid ? selectedItem.uuid : '',
                    userRole: selectedItem.isCustomItem ? '' : selectedItem.itemUuid || selectedItem.uuid,
                    userModule: selectedItem.orderQuantity,
                    delete: selectedItem.isDeleted ? 1 : 0,
                }));

                this.$validator.validateAll().then((res) => {
                    if (res) {
                        let formData = new FormData();
                        formData.append('quotationItem', JSON.stringify(toEdit));
                        if (this.$route.params.uuid !== undefined) {
                            this.$http
                            .patch(this.apiUrl.moduleAction, formData)
                            .then((response) => {
                                this.$store.dispatch('notification/success', 'Quotation has been updated.');
                            })
                            .catch((error) => {
                                this.$store.dispatch('notification/error', error);
                            });
                        }
                    } else {
                        swal('', 'Please fill the required fields!', 'info', {
                            buttons: false,
                            timer: 2000,
                        });
                    }
                });
            },
        }
    }
</script>